import { Popper, Box, SvgIconProps } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { ComponentType, useState } from "react";

interface Props {
  text: string;
  infoIconColor?:
    | "disabled"
    | "action"
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  /**
   * Replaces the default 12px MUI glyph, e.g. Figma's 16px vuesax info-circle
   * on the borrower-detail charts. Sized by `iconSize`, tinted by `iconColor`.
   */
  icon?: ComponentType<SvgIconProps>;
  /** Glyph size in px (default 12). */
  iconSize?: number;
  /** CSS colour for a custom `icon`, e.g. "var(--gray1)". */
  iconColor?: string;
}

const InfoPopper = (props: Props) => {
  const [infoAnchorEl, setInfoAnchorEl] = useState<null | SVGSVGElement>(null);
  const openInfo = Boolean(infoAnchorEl);
  const Trigger = props.icon ?? InfoIcon;

  const onInfoMouseEnter = (event: React.MouseEvent<SVGSVGElement>) => {
    setInfoAnchorEl(event.currentTarget);
  };

  const onInfoMouseLeave = () => {
    setInfoAnchorEl(null);
  };

  return (
    <span>
      <Trigger
        color={props.icon ? undefined : props.infoIconColor ?? "disabled"}
        // 12×12 per Figma info-circle — fontSize sizes both axes, so the box is
        // 12px wide (no leftover 24px width). inline-block keeps it on the same
        // line as the label; display:block forced it onto its own line.
        sx={{
          fontSize: `${props.iconSize ?? 12}px`,
          display: "inline-block",
          verticalAlign: "middle",
          ...(props.iconColor && { color: props.iconColor }),
        }}
        onMouseEnter={onInfoMouseEnter}
        onMouseLeave={onInfoMouseLeave}
      />
      <Popper
        open={openInfo}
        anchorEl={infoAnchorEl}
        placement="top-start"
        sx={{
          zIndex: 2000,
        }}
      >
        <Box display={"flex"} marginBottom={"7px"}>
          <Box
            width={"40px"}
            bgcolor={"var(--green)"}
            alignContent={"center"}
            textAlign={"center"}
            borderRadius={"4px 0 0 4px"}
          >
            <InfoIcon color="white" sx={{ height: "11px" }} />
          </Box>
          <Box
            bgcolor={"var(--white)"}
            p={"10px 16px 10px 16px"}
            borderRadius={"0 4px 4px 0"}
            maxWidth={"260px"}
          >
            {props.text}
          </Box>
        </Box>
        <img
          style={{ position: "absolute", bottom: 0, left: "5px" }}
          src="/img/tooltip-down.svg"
          alt="tooltip down"
          height={"8px"}
          width={"14px"}
        />
      </Popper>
    </span>
  );
};

export default InfoPopper;
